import { render, staticRenderFns } from "./CareRules.vue?vue&type=template&id=d4360602&scoped=true&"
import script from "./CareRules.vue?vue&type=script&lang=js&"
export * from "./CareRules.vue?vue&type=script&lang=js&"
import style0 from "./CareRules.vue?vue&type=style&index=0&id=d4360602&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4360602",
  null
  
)

export default component.exports